import { CloseCircle } from "iconsax-reactjs";
import { FC, memo } from "react";
import { useTranslation } from "react-i18next";
import { Appointment, Chat } from "@/components";
import { useClientHeight } from "@/hooks/useClientHeight";
import { selectUiSidebar } from "@/store/features/ui/selectors";
import { toggleUISidebar } from "@/store/features/ui/slice";
import { SideBarContent } from "@/store/features/ui/types";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { StyledBody, StyledCloseButton, StyledHeader, StyledSidebar } from "./styled";

const Sidebar: FC = () => {
  const {t} = useTranslation();

  const height = useClientHeight();

  const dispatch = useAppDispatch();
  const content = useAppSelector(selectUiSidebar);

  const onClose = () => {
    if (content !== null) {
      dispatch(
        toggleUISidebar({
          sidebar: content
        }),
      );
    }
  };

  const renderContent = () => {
    switch (content) {
      case SideBarContent.chat:
        return <Chat />;
      case SideBarContent.appointment:
        return <Appointment />;
      default:
        return null;
    }
  };

  const renderTitle = () => {
    switch (content) {
      case SideBarContent.chat:
        return t('chat');
      case SideBarContent.appointment:
        return t('appointment');
      default:
        return null;
    }
  };

  return (
    <StyledSidebar $height={height} $open={content !== null}>
      <StyledHeader>
        <h3>{renderTitle()}</h3>
        <StyledCloseButton onClick={onClose} aria-label="Close modal">
          <CloseCircle />
        </StyledCloseButton>
      </StyledHeader>
      <StyledBody $height={height}>
        {renderContent()}
      </StyledBody>
    </StyledSidebar>
  );
};

export default memo(Sidebar);